import Store from "./Store";
import Event from "./Event";
import $ from "jquery";

import materialized from 'materialize-css';

//import lightbox from 'lightbox2';

//lightbox.option({
//    'fadeDuration': 300,
//    'imageFadeDuration': 300
//});


var store = new Store;
var event = new Event;

store.fillStatusData();
store.showIteminfoSubData();

$('#hakkouNo').on('keypress', (e) => {
    if (e.keyCode === 13) {
        event.search(store);
        $('#hakkouNo').blur();
    }
});

$('#search').on('click', (e) => {
    event.search(store);
    $('#search').blur();
});

$('#hakkouNo').focus();
if ($('#hakkouNo').val() !== '') {
    event.search(store);
    $('#hakkouNo').blur();
}

$('.materialboxed').materialbox();

